import { callLambdaFunction } from '../aiClient';

// Supabase edge function slug. The function enforces auth + per-company
// daily rate limits before forwarding to OpenAI.
const CHAT_COMPLETION_ENDPOINT = 'chat-completion';

/**
 * Get chat completion from any AI provider
 * 
 * @param {string} provider - Provider identifier (e.g., 'ANTHROPIC', 'OPENAI')
 * @param {string} model - Model name
 * @param {array} messages - Messages array
 * @param {object} options - Additional parameters
 */
export async function getChatCompletion(provider, model, messages, options = {}) {
  const payload = {
    provider,
    model,
    messages,
    stream: false,
    parameters: options,
  };

  const response = await callLambdaFunction(
    CHAT_COMPLETION_ENDPOINT,
    payload
  );

  // Return full SDK response for maximum flexibility
  return response;
}

/**
 * Stream chat completion — emulated shim over the non-streaming edge function.
 *
 * The chat-completion edge function does not support SSE yet, so this
 * helper awaits the full response and then delivers it as a single chunk
 * shaped like the original streaming chunk contract, followed by onComplete.
 * Callers (e.g. useChat) therefore keep working without code changes.
 */
export async function getStreamingChatCompletion(
  provider,
  model,
  messages,
  onChunk,
  onComplete,
  onError,
  options = {}
) {
  try {
    const response = await getChatCompletion(provider, model, messages, options);
    const content = response?.choices?.[0]?.message?.content || '';
    // Single synthetic chunk mirroring the OpenAI delta shape so existing
    // onChunk handlers that read `choices[0].delta.content` still work.
    onChunk?.({
      choices: [{ index: 0, delta: { content } }],
    });
    onComplete?.();
  } catch (error) {
    console.error('Streaming shim error:', error);
    onError?.(error);
  }
}